import { render } from "./index.vue?vue&type=template&id=51ac5b9b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=51ac5b9b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51ac5b9b"

export default script